// Central media config. Paste your real links/URLs here to go live.
// reelEmbedUrl: a YouTube, Vimeo or Instagram post/reel URL (leave "" for poster-only placeholder).
export const MEDIA = {
  reelEmbedUrl: "",
  reelPoster: "/gallery-pickup.webp",
  reelLength: "",
};
